import React from 'react'
import filterDescend from '../../assets/icons/expand_more.svg'
import filterAscend from '../../assets/icons/expand_less.svg'

const HeaderFilter = props => {

  const filterDescendCallback = () => {
    if (props.descend) {
      props.descend(props.dataKey)
    }
  }

  const filterAscendCallback = () => {
    if (props.ascend) {
      props.ascend(props.dataKey)
    }
  }
  return(
    <div className='df fxdrc'>
      <img onClick={filterAscendCallback} className='mb-5 ml1' src={filterAscend} alt='filter acending order'/>
      <img onClick={filterDescendCallback} className='ml1' src={filterDescend} alt='filter descending order'/>
    </div>
  )
}

export default HeaderFilter